import { Button, Flex, Textarea, Typography } from "@aircall/tractor";
import { useTranslation } from "react-i18next";

import { SubmitButton } from "@/components/SubmitButton";

import { useEvaluationUpdateForm } from "@/hooks/useEvaluationUpdateForm/useEvaluationUpdateForm";
import { useEvaluationUpdateFormInteractions } from "@/hooks/useEvaluationUpdateFormActions/useEvaluationUpdateFormActions";
import { EvaluationFormFooterProps } from ".";

export function EvaluationUpdateFormFooter({
  onClickCancel,
  loading,
}: Readonly<EvaluationFormFooterProps>) {
  const { t } = useTranslation();

  const { form } = useEvaluationUpdateForm();

  const { hasUnansweredQuestions, overallMaxScore, overallScore } =
    useEvaluationUpdateFormInteractions();

  return (
    <Flex flexDirection="column" gap="xxxs">
      <Flex p="s" flexDirection="column" gap="xs">
        <Flex justifyContent="space-between" alignItems="center">
          <Typography variant="headingBoldXS">
            {t("evaluation.overall_title")}
          </Typography>
          <Typography variant="bodyRegularS">
            {t("evaluation.overall_score", {
              score: overallScore,
              maxScore: overallMaxScore,
            })}
          </Typography>
        </Flex>
        <Flex flexDirection="column" gap="s">
          <form.Field name="feedback">
            {(field) => (
              <Textarea
                value={field.state.value}
                onChange={(event) => {
                  field.handleChange(event.target.value);
                }}
                placeholder={t("evaluation.add_feedback")}
              />
            )}
          </form.Field>
          <Flex gap="xxs" justifyContent="flex-end">
            <Button
              onClick={onClickCancel}
              variant="secondary"
              size="small"
              mode="ghost"
              data-test="evaluation-cancel-button"
            >
              {t("cancel")}
            </Button>
            <SubmitButton
              data-test="evaluation-submit-button"
              type="submit"
              loading={loading}
              disabled={hasUnansweredQuestions > 0}
              size="small"
            >
              {t("update")}
            </SubmitButton>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}
